import ImageListItem from '@mui/material/ImageListItem';
import { useState } from 'react';
import { normalizeHeight } from '../../../utils/normalize';
import SnipzInformation from '../SnipzInformation';
import SnipzPlayer from '../SnipzPlayer';

type SnipzPostProps = {
  authorAvatarUrl: string;
  authorId: string,
  authorUsername: string,
  id: string,
  type: string,
  isLiked: boolean,
  medias:
  {
    name: string,
    size: string,
    type: string,
    url: string
  }[],
  description: string[],
  tags: string[],
  likes: number,
  comments: number,
  createdAt: string,
  updatedAt: string,
  index?: number;
  carouselIndex?: number;
  feedType: string;
}

export default function SnipzPost({
  authorAvatarUrl,
  authorId,
  authorUsername,
  id,
  type,
  medias,
  description,
  tags,
  likes,
  comments,
  createdAt,
  updatedAt,
  isLiked,
  index,
  carouselIndex,
  feedType
}: SnipzPostProps) {
  const [likesCount, setLikesCount] = useState<number>(likes)
  const [commentsCount, setCommentsCount] = useState<number>(comments)
  const [isLikedState, setIsLikedState] = useState<boolean>(isLiked)

  return (
    <ImageListItem
      key={id}
      style={{
        height: normalizeHeight(790),
        width: 'fit-content',
        maxWidth: normalizeHeight(845),
        display: 'flex',
        flexDirection: 'row',
        boxShadow: '0px 2px 8px 0px #8C879699',
        marginLeft: 12,
        marginRight: 12,
        marginTop: 12,
        borderRadius: 8,
      }}
    >
      <SnipzPlayer isCurrent={carouselIndex === index} modal={false} isFeed={false} local={false} src={medias[0].url} />
      <SnipzInformation
        publicationId={id}
        selectedImage={0}
        authorUsername={authorUsername}
        authorAvatarUrl={authorAvatarUrl}
        timeSince={createdAt}
        descriptions={description}
        tags={tags}
        feedType={feedType}
        likes={likes}
        comments={comments}
        liked={isLikedState}
        setLiked={setIsLikedState}
        likesCount={likesCount}
        setLikesCount={setLikesCount}
        commentsCount={commentsCount}
        setCommentsCount={setCommentsCount}
      />
    </ImageListItem>
  );
}